/**
 * 常用正则
 * Created by luobinhang on 2018/10/11 at 下午5:15.
 */

/**
 * 手机号正则
 */
export const phoneRegExp = new RegExp(/^1\d{10}$/);

/**
 * 身份证号正则
 * 支持15位（旧版）和18位（新版）身份证号
 * 15位格式：6位地区码 + 6位出生日期(YYMMDD) + 3位顺序码
 * 18位格式：6位地区码 + 8位出生日期(YYYYMMDD) + 3位顺序码 + 1位校验码
 */
export const idCardRegExp = new RegExp(
  /^[1-9][0-9]{14}([0-9]{2}[0-9Xx])?$/,
);

/**
 * Email正则
 */
export const emailRegExp = new RegExp(
  /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
);

/**
 * 中文正则
 */
export const zhCharReg = /[\u4e00-\u9fa5]/;
